/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aroma_Sampling_GrowerInputs */

const vi_aroma_sampling_grower = /** @type {(inputs: Aroma_Sampling_GrowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hộ trồng chè`)
};

/**

* @param {Aroma_Sampling_GrowerInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aroma_sampling_grower = /** @type {((inputs?: Aroma_Sampling_GrowerInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aroma_Sampling_GrowerInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aroma_sampling_grower(inputs)
});